import {
  authTokenStorage,
} from '@/plugins/auth-token-storage';
import {
  AuthState,
} from '@/store/modules/auth/types';

export const state: AuthState = {
  isAuthenticated: !!(authTokenStorage.value && Object.values(authTokenStorage.value).length),
};
